import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./RightsManagement.css";

const Intro = ({ headingbefore, mark, headingafter, detail, imageurl }) => {
  return (
    <div className="rm-intro">
      <Container>
        <Row className="align-items-center">
          <Col lg={5} className="mb-5 mb-lg-0">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="mini-title">WHY CHOOSE FT TUNES</div>
              <h2>
                {headingbefore} <span className="text-gradient-orange">{mark}</span> for the Best Music Copyright Management <span className="text-gradient-purple">Services</span> {headingafter.replace('for the Best Music Copyright Management Services ', '')}
              </h2>
              <p style={{ color: "#94a3b8", fontSize: "14px", lineHeight: "1.6", marginBottom: "20px" }}>
                {detail}
              </p>
            </motion.div>
          </Col>
          <Col lg={7} className="text-center text-lg-end">
            <motion.img
              src="/Images/sell-your-music-worldwide.png"
              alt="Why Choose FT Tunes"
              className="img-fluid"
              style={{ borderRadius: "50px", maxWidth: "100%", height: "auto" }}
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Intro;
